
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Pie/index.md?watch=parent';
    export const demoIndex = {
  ids: ["pie-demo-common","pie-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Pie" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Pie/index.md?type=demo')
};